import { render } from "./AccountTypeShow.vue?vue&type=template&id=d06f52e2"
import script from "./AccountTypeShow.vue?vue&type=script&lang=js"
export * from "./AccountTypeShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__